import { PersonnelReportUIProvider } from "./PersonnelReportUIContext";
import { PersonnelReportCard } from "./PersonnelReportCard";

export function PersonnelReportPage() {
  return (
    <PersonnelReportUIProvider>
      <PersonnelReportCard />
    </PersonnelReportUIProvider>
  );
}